(() => {
    let productCard = document.getElementsByClassName('product-card');
    let pos = window.pageYOffset;
    getVariant();

    function getVariant() {
        for (let i = 0; i < productCard.length; i++) {
            let product = productCard[i];
            let productCardImageContainer = product.getElementsByClassName('product-card__figure')[0];
            let imageLink = productCardImageContainer.getElementsByClassName('link-image')[0];

            if(imageLink) {
                let imageLinkHref = imageLink.getAttribute('href');
                let imageAlt = imageLink.getElementsByClassName('product-card__image')[0].alt;
                let productVariantscontainer = product.getElementsByClassName('product-card__aside')[0];
    
                if (productVariantscontainer && imageAlt) {
                    let actualVariant = product.getElementsByClassName('sr-only-variant');
    
                    for (let x = 0; x < actualVariant.length; x++) {
                        if(actualVariant[x].dataset.variantMedia) {
                            let dataMedia = actualVariant[x].dataset.variantMedia;
                            let dataMediaJson = JSON.parse(dataMedia);
                            let includesAlt = dataMedia.includes(imageAlt);
    
                            if (imageAlt == dataMediaJson.alt) {
                                let variantID = actualVariant[x].dataset.variantId;
                                imageLink.href = `${imageLinkHref}?variant=${variantID}`;
                                actualVariant[x].checked = true;
                            }
                        }
                    }
                }
            }
        }
    };
})()